var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKakao = function SvgIconKakao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.477 2 2 5.825 2 10.544c0 3.051 1.872 5.728 4.687 7.24-.153.572-.984 3.682-1.017 3.927 0 0-.02.183.09.253s.238.016.238.016c.315-.048 3.649-2.585 4.226-3.026.576.088 1.17.134 1.776.134 5.523 0 10-3.825 10-8.544S17.523 2 12 2Z",
    fill: "#fff"
  })));
};
export default SvgIconKakao;